<template>
  <div>
    <b-form-group label="Section name">
      <b-form-input
        v-model="sectionName"
        placeholder="Please type new section title"
        @input="sendNameValueToParent"
      />
    </b-form-group>
    <b-form-checkbox
      v-model="isSectionVisible"
      @change="sendVisibilityStateToParent"
    >
      Is section visible
    </b-form-checkbox>
  </div>
</template>

<script>

import {createNamespacedHelpers} from 'vuex';

const {
  mapState: designerMapState,
  mapActions: designerMapActions,
} = createNamespacedHelpers('designer');
export default {
  name: 'GeneralEditorComponent',
  props: ['isTitleVisible'],
  data() {
    return {
      sectionName: '',
      isSectionVisible: true,
    };
  },
  computed: {
    ...designerMapState({
      isModalOpened: state => state.addEditSectionModal,
      title: state => state.customisationsModal.title,
    }),
  },
  methods: {
    ...designerMapActions(['changeSectionTitle']),
    sendNameValueToParent(val) {
      this.$emit('get-section-name', val);
    },
    sendVisibilityStateToParent(val) {
      this.$emit('get-title-visibility', val);
    },
  },
  mounted() {
    this.sectionName = this.title;
    this.isSectionVisible = this.isTitleVisible;
  },
};
</script>